module.exports = __webpack_public_path__ + "static/media/couches-4.a165fdf8.jpg";